import { CostSource } from '@onereach/billing-shared';
import type { SelectItem } from '@onereach/ui-components';

export const awsSourceOptions: SelectItem[] = [
  {
    label: 'Vantage',
    value: CostSource.VANTAGE,
  },
  {
    label: 'Native AWS',
    value: CostSource.NATIVE_AWS,
  },
];

export const telephonySourceOptions: SelectItem[] = [
  {
    label: 'Twilio',
    value: CostSource.TWILIO,
  },
  {
    label: 'Vonage',
    value: CostSource.VONAGE,
  },
  {
    label: 'Telnyx',
    value: CostSource.TELNYX,
  },
  {
    label: 'Bandwidth',
    value: CostSource.BANDWIDTH,
  },
];

export const aiSourceOptions: SelectItem[] = [
  {
    label: 'OpenAI',
    value: CostSource.OPENAI,
  },
  {
    label: 'Deepgram',
    value: CostSource.DEEPGRAM,
  },
];

export const sourceOptions: SelectItem[] = [...awsSourceOptions, ...telephonySourceOptions, ...aiSourceOptions];
